import { Link } from 'types/layout';

export const contactOurTeamLink: Link = {
	text: 'contact our team',
	href: '/contact'
};

export const contactSupportLink: Link = {
	text: 'Contact support',
	href: '/contact'
};

export const backToDashboardLink: Link = {
	text: 'Back to dashboard',
	href: '/account/overview'
};

export const investmentsEmailLink: Link = {
	text: 'investments@fundrise.com',
	href: 'mailto:investments@fundrise.com'
};

export const supportEmailLink: Link = {
	text: 'support@fundrise.com',
	href: 'mailto:support@fundrise.com'
};